module.exports = __webpack_public_path__ + "static/media/icon-pause-youtube.9bf02423.svg";